import { render, staticRenderFns } from "./SettingsIndividualExtra.vue?vue&type=template&id=6a2e7c58&scoped=true&"
import script from "./SettingsIndividualExtra.vue?vue&type=script&lang=js&"
export * from "./SettingsIndividualExtra.vue?vue&type=script&lang=js&"
import style0 from "./SettingsIndividualExtra.vue?vue&type=style&index=0&id=6a2e7c58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2e7c58",
  null
  
)

export default component.exports